const FroalaEditor = require('froala-editor/js/froala_editor.min.js');
window.FroalaEditor = FroalaEditor.default ?? FroalaEditor;
global.FroalaEditor = window.FroalaEditor;
// ---------------------------
// Imports
// ---------------------------
import flatPickr from 'vue-flatpickr-component';
import Multiselect from '@vueform/multiselect'
import 'scroll-shadow-element';
import 'flatpickr/dist/flatpickr.css';
import 'cropperjs/src/css/cropper.scss';
import 'dropzone/dist/dropzone.css'
import '@vueform/multiselect/themes/default.css';

// Initialize a new object if it doesn't exist
window.PEERISTICS = window.PEERISTICS || {};

import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';

// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';

// Import Froala Editor Fontawesome
import 'froala-editor/css/third_party/font_awesome.min.css';
import 'froala-editor/js/third_party/font_awesome.min.js';

import { createApp } from 'vue';
import { createI18n } from 'vue-i18n'
import VueFroala from 'vue-froala-wysiwyg'

import './icons';
import ExamIndexVue from '../../vue/networks/admin/exams/components/ExamIndex.vue'
import FilterBar from '../../vue/filter_bar/components/Main.vue'
import Pagination from '../../vue/shared/pagination/Pagination.vue'
import ContentBlockShare from '../../vue/content_blocks/share/components/ContentBlockShare.vue'
import ContainerSelection from '../../vue/networks/admin/memberships/components/ContainerSelection.vue'
import Flash from '../../vue/networks/admin/memberships/components/ContainerSelection.vue'
import InviteUserForm from '../../vue/networks/admin/memberships/components/InviteUserForm.vue'
import DatePicker from '../../vue/shared/schedule_status_change/components/DatePicker.vue'
import Calendar from '../../vue/shared/daybook/components/Calendar.vue'
import ManageFeatures from '../../vue/networks/admin/container_types/components/ManageFeatures.vue'
import ManageRoles from '../../vue/networks/admin/container_types/components/ManageRoles.vue'
import ManageFeatureRoles from '../../vue/networks/admin/container_types/components/ManageFeatureRoles.vue'
import Objectives from '../../vue/shared/objectives/components/Objectives.vue'
import UserSelection from '../../vue/shared/memberships/components/UserSelection.vue'
import ScheduledItem from '../../vue/shared/scheduled_items/components/ScheduledItem.vue'
import Import from '../../vue/networks/admin/containers/components/Import.vue'
import Cropper from '../../vue/cropper/components/Cropper.vue'
import Dropzone from '../../vue/file_upload/components/Dropzone.vue'
import ManageSurvey from '../../vue/surveys/components/ManageSurvey.vue'
import SubmitOnboardingSurvey from '../../vue/surveys/components/SubmitOnboardingSurvey.vue'
import SubmitRegistrationSurvey from '../../vue/surveys/components/SubmitRegistrationSurvey.vue'
import ContainerManagement from '../../vue/containers/admin/components/ContainerManagement.vue'
import ContainerTrainingAgreementManagement from '../../vue/containers/admin/components/ContainerTrainingAgreementManagement.vue'
import ContainerTrainingAgreementForm from '../../vue/containers/admin/components/ContainerTrainingAgreementForm.vue'
import ManageContainerMetadata from '../../vue/networks/admin/container_types/components/ManageContainerMetadata.vue'
import Listing from '../../vue/logbooks/components/Listing.vue'
import LogbookForm from '../../vue/logbooks/components/LogbookForm.vue'
import TrainingProgramForm from '../../vue/networks/admin/logbooks/components/TrainingProgramForm.vue'
import ProgramStandardForm from '../../vue/networks/admin/logbooks/components/ProgramStandardForm.vue'
import TrainingProgramTabs from '../../vue/networks/admin/logbooks/components/TrainingProgramTabs.vue'
import TrainingStandardIndex from '../../vue/networks/admin/logbooks/components/TrainingStandardIndex.vue'
import HistoryTab from '../../vue/logbooks/components/HistoryTab.vue'
import SkillsListing from '../../vue/logbooks/components/SkillsListing.vue'
import SkillSetsListing from '../../vue/logbooks/components/SkillSetsListing.vue'
import ProgramStandardIndex from '../../vue/networks/admin/logbooks/components/ProgramStandardIndex.vue'
import InviteNetworkUser from '../../vue/shared/memberships/components/InviteNetworkUser.vue'
import SubmitQuestions from '../../vue/shared/containers/components/SubmitQuestions.vue'
import LoadingAnimation from '../../vue/shared/loader/components/LoadingAnimation.vue'
import StatusForm from '../../vue/networks/admin/status_management/components/StatusForm.vue'
import StatusListing from '../../vue/networks/admin/status_management/components/StatusListing.vue'
import ListingFormat from '../../vue/shared/listing/ListingFormat.vue'
import ProgressBar from '../../vue/shared/progress_bar/ProgressBar.vue'
import LogbooksWidget from '../../vue/widgets/LogbooksWidget.vue'
import Breadcrumbs from '../../vue/shared/breadcrumbs/components/Breadcrumbs.vue'
import AssetList from '../../vue/assets/components/AssetList.vue'
import Asset from '../../vue/assets/components/Asset.vue'
import LogbookHours from '../../vue/logbooks/components/LogbookHours.vue'
import HoursFormRow from '../../vue/logbooks/components/HoursFormRow.vue'
import HoursHistoryTab from '../../vue/logbooks/components/HoursHistoryTab.vue'
import TableTopNav from '../../vue/shared/table_top_nav/TableTopNav.vue'
import NumberInput from '../../vue/shared/inputs/NumberInput.vue'
import ExamTypeIndex from '../../vue/networks/admin/exams/components/ExamTypeIndex.vue'
import VueFroalaEditor from '../../vue/shared/FroalaEditor/FroalaEditor.vue'
import ExamTypeForm from '../../vue/networks/admin/exams/components/ExamTypeForm.vue'
import ExamForm from '../../vue/networks/admin/exams/components/ExamForm.vue'
import TextInput from '../../vue/shared/components/TextInput.vue'
import ExamView from '../../vue/networks/admin/exams/components/ExamView.vue'
import ExamTypeView from '../../vue/networks/admin/exams/components/ExamTypeView.vue'
import InventoryExamIndex from '../../vue/networks/admin/inventory/components/InventoryExamIndex.vue'
import InventoryExamReport from '../../vue/networks/admin/inventory/components/InventoryExamReport.vue'
import ExamBookIndex from '../../vue/networks/admin/inventory/components/ExamBookIndex.vue'
import ExamBookForm from '../../vue/networks/admin/inventory/components/ExamBookForm.vue'
import SubLocationIndex from '../../vue/scheduling/components/SubLocationIndex.vue'
import SubLocationForm from '../../vue/scheduling/components/SubLocationForm.vue'
import ShowSubLocation from '../../vue/scheduling/components/ShowSubLocation.vue'
import BookingTrainingPrograms from '../../vue/scheduling/booking/components/BookingTrainingPrograms.vue'
import BookingExamType from '../../vue/scheduling/booking/components/BookingExamType.vue'
import BookingAccommodation from '../../vue/scheduling/booking/components/BookingAccommodation.vue'
import BookingSitting from '../../vue/scheduling/booking/components/BookingSitting.vue'
import BookingPayment from '../../vue/scheduling/booking/components/BookingPayment.vue'
import BookingUserSearch from '../../vue/scheduling/booking/components/BookingUserSearch.vue'
import BookingConfirmation from '../../vue/scheduling/booking/components/BookingConfirmation.vue'
import BookingForm from '../../vue/scheduling/booking/components/BookingForm.vue'
import SittingForm from '../../vue/scheduling/components/SittingForm.vue'
import SeriesForm from '../../vue/scheduling/components/SeriesForm.vue'
import WeekCalendar from '../../vue/shared/calendar/components/Calendar.vue'
import Week from '../../vue/shared/calendar/components/Week.vue'
import SessionDetails from '../../vue/shared/calendar/components/SessionDetails.vue'
import ContainerForm from '../../vue/networks/admin/containers/components/ContainerForm.vue'
import CertificateForm from '../../vue/networks/admin/certificates/components/CertificateForm.vue'
import ExamReport from '../../vue/scheduling/components/ExamReport.vue'
import ContainerMembersList from '../../vue/containers/admin/components/ContainerMembersList.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import customValidationMessages from './_locales/errorMessages.js';
import ShortcutsWidget from '../../vue/widgets/ShortcutsWidget.vue';
// import NetworkOptionDetails from '../../vue/networks/admin/network_settings/components/NetworkOptionDetails.vue'

// ---------------------------
// Vue App Initialization
// ---------------------------
const app = createApp({}); // Vue 3: do NOT use 'new'

// Set up i18n
const i18n = createI18n({messages: customValidationMessages});
window.addEventListener('DOMContentLoaded', (event) => {
  const htmlTag = document.getElementsByTagName('html')[0];
  let locale = 'en';
  if(htmlTag && htmlTag.getAttribute('lang')){
      locale = htmlTag.getAttribute('lang');
  }
  i18n.global.locale = locale;
});

// Use Froala and i18n
app.use(VueFroala);
app.use(i18n);

// ---------------------------
// Register Components
// ---------------------------
app.component('flat-pickr', flatPickr);
app.component('multi-select', Multiselect);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component("exam-index-vue", ExamIndexVue)
app.component('content-block-share-vue', ContentBlockShare);
app.component('container-selection-vue', ContainerSelection);
app.component("flash-vue", Flash);
app.component("invite-user-form-vue", InviteUserForm);
app.component('date-picker-vue', DatePicker);
app.component('calendar-vue', Calendar);
app.component('manage-container-type-features-vue', ManageFeatures);
app.component('manage-container-type-roles-vue', ManageRoles);
app.component('manage-container-type-feature-roles-vue', ManageFeatureRoles);
app.component('objectives-vue', Objectives);
app.component('user-selection-vue', UserSelection);
app.component('scheduled-item-vue', ScheduledItem);
app.component('container-import-vue', Import);
app.component('cropper-vue', Cropper);
app.component('filter-bar-main-vue', FilterBar);
app.component('upload-vue', Dropzone);
app.component('manage-survey-vue', ManageSurvey);
app.component('submit-onboarding-survey-vue', SubmitOnboardingSurvey);
app.component('submit-registration-survey-vue', SubmitRegistrationSurvey);
app.component('container-management-vue', ContainerManagement);
app.component('container-training-agreement-management-vue', ContainerTrainingAgreementManagement);
app.component('container-training-agreement-form-vue', ContainerTrainingAgreementForm);
app.component('manage-container-metadata-vue', ManageContainerMetadata);
app.component("logbooks-listing-vue", Listing);
app.component("logbook-form-vue", LogbookForm);
app.component("training-program-form-vue", TrainingProgramForm);
app.component("program-standard-form-vue", ProgramStandardForm);
app.component("training-program-tabs-vue", TrainingProgramTabs);
app.component("training-standard-index-vue", TrainingStandardIndex);
app.component("history-tab-vue", HistoryTab);
app.component("skills-listing-vue", SkillsListing);
app.component("skill-sets-listing-vue", SkillSetsListing);
app.component("program-standard-index-vue", ProgramStandardIndex);
app.component("submit-questions-vue", SubmitQuestions);
app.component("invite-network-user-vue", InviteNetworkUser);
app.component("loading-animation-vue", LoadingAnimation);
app.component("status-form-vue", StatusForm);
app.component("status-listing-vue", StatusListing);
app.component("listing-format-vue", ListingFormat);
app.component("progress-bar-vue", ProgressBar);
app.component("logbooks-widget-vue", LogbooksWidget);
app.component("breadcrumbs-vue", Breadcrumbs);
app.component("asset-list-vue", AssetList);
app.component("asset-vue", Asset);
app.component("logbook-hours-vue", LogbookHours);
app.component("hours-form-row-vue",  HoursFormRow);
app.component("hours-history-tab",  HoursHistoryTab);
app.component("table-top-nav",  TableTopNav);
app.component("number-input",  NumberInput);
app.component('froala-editor-vue', VueFroalaEditor);
app.component('exam-type-index-vue', ExamTypeIndex);
app.component('exam-type-form-vue', ExamTypeForm);
app.component('exam-form-vue', ExamForm);
app.component("text-input-vue", TextInput);
app.component('exam-view-vue', ExamView);
app.component('exam-type-view-vue', ExamTypeView);
app.component('inventory-exam-index-vue', InventoryExamIndex);
app.component('inventory-exam-report-vue', InventoryExamReport);
app.component('exam-book-index-vue', ExamBookIndex);
app.component('exam-book-form-vue', ExamBookForm);
app.component('sub-location-index-vue', SubLocationIndex);
app.component('sub-location-form-vue', SubLocationForm);
app.component('show-sub-location-vue', ShowSubLocation);
app.component('booking-training-programs-vue', BookingTrainingPrograms);
app.component('booking-exam-type-vue', BookingExamType);
app.component('booking-accommodation-vue', BookingAccommodation);
app.component('booking-sitting-vue', BookingSitting);
app.component('booking-payment-vue', BookingPayment);
app.component('booking-user-search-vue', BookingUserSearch);
app.component('booking-confirmation-vue', BookingConfirmation);
app.component('booking-form-vue', BookingForm);
app.component('sitting-form-vue', SittingForm);
app.component('series-form-vue', SeriesForm);
app.component('calendar-week-vue', WeekCalendar);
app.component('week-vue', Week);
app.component('session-details-vue', SessionDetails);
app.component("pagination-vue", Pagination);
app.component("container-form-vue", ContainerForm);
app.component('certificate-form-vue', CertificateForm);
app.component("exam-report-vue", ExamReport);
app.component("container-members-list-vue", ContainerMembersList);
app.component("shortcuts-widget-vue", ShortcutsWidget);


// app.component("network-option-details-vue", NetworkOptionDetails);

// ---------------------------
// Mount
// ---------------------------
app.mount("#peeristics-app-body");

export { i18n };
